import "./src/styles/global.css"
import "react-international-phone/style.css"
import React from 'react';
import GeoModal from './src/components/GeoModal';

export const wrapPageElement = ({ element }) => (
    <>{element}<GeoModal /></>
);
